import { GanttContext } from "./gantt.context";
import { GanttBodyView } from "./parts/view-body";
import { GanttHeaderView } from "./parts/view-header";
import type { GanttProps } from "./types-gantt";
import { useGantt } from "./use-gantt";
import { GanttView } from "./view-gantt";

/**
 * Base dos Gantts do Hub: colunas fixas (sticky) à esquerda, escala por mês ou por dia com rolagem horizontal, grade,
 * linha Hoje, marcos (limite, início), grupos recolhíveis e a coluna ⋮. A tela informa as colunas, as linhas (células e
 * conteúdo da área temporal, montado com os átomos `GanttBar`, `LineMark` e `PillMark` do DS) e os marcos.
 */
export function GanttRoot(props: GanttProps) {
  const viewModel = useGantt(props);

  return (
    <GanttContext.Provider value={viewModel.context}>
      <GanttView
        testId={viewModel.testId}
        className={viewModel.className}
        style={viewModel.style}
        corpoRola={viewModel.corpoRola}
        rest={viewModel.rest}
        tooltipRef={viewModel.tooltipRef}
        menuRef={viewModel.menuRef}
        menuModel={viewModel.menuModel}
        menuTestId={viewModel.menuTestId}
        scrollerTestId={viewModel.scrollerTestId}
        scrollerRef={viewModel.scrollerRef}
        tableStyle={viewModel.tableStyle}
        tableLabel={viewModel.tableLabel}
      >
        <GanttHeaderView />
        <GanttBodyView />
      </GanttView>
    </GanttContext.Provider>
  );
}
GanttRoot.displayName = "Gantt.Root";
